import React from 'react';
import { StyledRadioButton } from './styled';
import { ReactComponent as EquipIcon } from 'assets/icons/equip-icon-gray.svg';
import { ReactComponent as AreaIcon } from 'assets/icons/area-icon-gray.svg';
import { ReactComponent as CheckedIcon } from 'assets/icons/checked-icon-orange.svg';

const RadioButton = ({ disabled, isActive, onClick, text, width }) => {
  const selectIcon = text => {
    if (text === 'Equipamento') {
      return <EquipIcon />;
    } else {
      return <AreaIcon />;
    }
  };
  return (
    <StyledRadioButton disabled={disabled} isActive={isActive} width={width} onClick={disabled ? null : onClick}>
      {isActive && <CheckedIcon />}
      {selectIcon(text)}
      {text}
    </StyledRadioButton>
  );
};

export { RadioButton };
